export default __webpack_public_path__ + "static/media/group_plan_logo_new.aebaffe6.png";